import api from '../axios';

/**
 * Serviço para dados de usuários
 */
class UsuariosService {
  /**
   * Obtém dados de usuários para uma data específica
   * @param {string} dataRef - Data de referência (formato: YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} Response da API com dados de usuários
   */
  async getUsuarios(dataRef) {
    try {
      const response = await api.get('/api/usuarios', {
        params: {
          dataRef: dataRef
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      throw error;
    }
  }
}

const usuariosService = new UsuariosService();
export default usuariosService;
